import { useContext } from "react";
import { useQuery } from "react-query";
import { UserKeys } from "../keys";
import { SnackbarContext } from "../../hooks/SnackbarContext";
import { getUserDetailsByUserName } from "../../services/UserService/UserService";

export const useUserByUserName = (userName: string) => {
  const { addSnack } = useContext(SnackbarContext);

  return useQuery(
    [UserKeys.GetuserByUserName, userName],
    (context) => getUserDetailsByUserName(userName),
    {
      enabled: false,
      refetchOnWindowFocus: false,
      staleTime:0,
      cacheTime: 0,
      onError: (_err: any) => {
        addSnack({
          severity: "error",
          message: _err.response?.data?.message ?? "Error retrieving user",
          duration: 3000,
        });
      },
      retry: (failureCount, error: any) =>
        failureCount < 3 && error?.status === 500
    }
  );
};
